import ChatMessagesHeader  from './ChatMessagesHeader';

export default ChatMessagesHeader;
